"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDefaultInterceptor = void 0;
var ApiManager_1 = require("./ApiManager");
/**
 * 사용자 세션(로그아웃) 관리
 */
var AddDefaultInterceptor = /** @class */ (function (_super) {
    __extends(AddDefaultInterceptor, _super);
    function AddDefaultInterceptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddDefaultInterceptor.getInstance = function (initValue) {
        if (!AddDefaultInterceptor.classInstance) {
            this.classInstance = new AddDefaultInterceptor(initValue);
        }
        return this.classInstance;
    };
    AddDefaultInterceptor.prototype.addInterceptor = function (callback) {
        // 타입오류로 인해 임시 any타입 지정
        this.defaultInterceptor(callback);
    };
    return AddDefaultInterceptor;
}(ApiManager_1.ApiManager));
exports.AddDefaultInterceptor = AddDefaultInterceptor;
